import { OperatorFunction, Observable, Subject, } from 'rxjs';

// create window, new window will be opened when comparer returns falsy
export function windowByComparator<T>(comparer: (a: T, b: T) => boolean): OperatorFunction<T, Observable<T>> {

  return (input$) => new Observable((observer) => {

    let current: T | null = null;
    let currentTarget: Subject<T>;

    return input$.subscribe({

      next(x) {

        if (current === null || !comparer(x, current)) {
          if (currentTarget) {
            currentTarget.complete();
          }

          current = x;
          currentTarget = new Subject<T>();
          observer.next(currentTarget);
        }

        currentTarget.next(x);
      },
      error(err) { observer.error(err); },
      complete() {
        if (currentTarget) { currentTarget.complete( ); }
        observer.complete();
      }
    });
  });
}
